import FromContact from "./FromContact";

const Contact = () => {
 return (
  <div className="contact-section-five" id="contact-us">
   <div className="contact-meta ZXmt-130 zlg-mt-60">
    <div className="row gx-0">
     <div className="col-xl-6 order-xl-first d-flex " data-aos="fade-right">
      <div className="area-contact-message flex items-center justify-center">
       <h2 className="text-message">
        ¡Déjanos un mensaje
        <br />
        para comunicarnos
        <br />
        contigo ahora!
       </h2>
      </div>
     </div>
     <div className="col-xl-6 order-xl-last d-flex " data-aos="fade-left">
      <div className="form-wrapper w-100 white-bg">
       <div className="form-style-three">
        {/* <h3 className="form-title font-recoleta pb-30 lg-pb-20 ">
                                        Send Message.
                                    </h3> */}
        <FromContact className="theme-btn-four " />
       </div>
      </div>
     </div>
    </div>
   </div>
  </div>
 );
};

export default Contact;
